<template>
  <v-container fluid>
    <h1 class="headline">{{ $t('pages.accounting.title') }}</h1>
    <DateIntervalPicker
      v-model="interval"
      class="mb-3">
    </DateIntervalPicker>
    <v-progress-circular v-if="loading" indeterminate></v-progress-circular>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="experts"
        :custom-sort="a => a"
        hide-actions>
        <template slot="items" scope="props">
          <td>
            <router-link 
              :to="{ name: 'Expert', params: { id: props.item.expert.id, tab: 'profile' } }">
              {{ props.item.expert.nickname }}
            </router-link>
          </td>
          <td class="text-xs-right">
            <minute :value="props.item.statistics.call_sum"/>
            <span v-if="props.item.statistics.call_sum">(<price :value="phoneGains(props.item.statistics)" />)</span>
            <span v-else>-</span>
          </td>
          <td class="text-xs-right"><price :value="gain('mail', props.item.expert, props.item.statistics)" /></td>
          <td class="text-xs-right"><price :value="gain('service', props.item.expert, props.item.statistics)" /></td>
          <td class="text-xs-right"><price :value="gain('product', props.item.expert, props.item.statistics)" /></td>
          <td class="text-xs-right"><price :value="gain('availability', props.item.expert, props.item.statistics)" /></td>
          <td class="text-xs-right">
            <strong>
              <price :value="total(props.item.expert, props.item.statistics)" />
            </strong>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Metrics from '@/api/metrics'
  import { Minute, Price } from '@/components/formatters'
  import withInterval from '@/mixins/withInterval'
  export default {
    components: {
      Minute,
      Price
    },
    mixins: [withInterval],
    data () {
      return {
        experts: [],
        loading: false
      }
    },
    computed: {
      ...mapGetters({
        platform: 'skiliko/session/currentPlatform'
      }),
      headers () {
        return [
          { text: this.$t('pages.statistics.expert'), left: true, sortable: false },
          { text: this.$t('pages.statistics.call'), left: false, sortable: false },
          { text: this.$t('pages.statistics.email'), left: false, sortable: false },
          { text: this.$t('pages.statistics.service'), left: false, sortable: false },
          { text: this.$t('pages.statistics.product'), left: false, sortable: false },
          { text: this.$t('pages.statistics.chat'), left: false, sortable: false },
          { text: this.$t('pages.statistics.total'), left: false, sortable: false }
        ]
      }
    },
    methods: {
      async reloadStats () {
        this.loading = true
        this.experts = (await Metrics.generalExpertStats({ params: this.params })).data
        this.loading = false
      },
      phoneGains (stat) {
        return stat.call_sum / 60 * this.platform.settings.fix_minute_price
      },
      gain (service, expert, stat) {
        const repartition = [
          (expert.repartition || {})[service],
          (this.platform.settings.default_expert_repartition || {})[service]
        ].filter(x => x !== undefined)[0] || 0
        return stat[`${service}_sum`] * repartition / 100
      },
      total (expert, stat) {
        return this.phoneGains(stat) + [
          'mail',
          'service',
          'product',
          'availability'
        ].reduce((prev, x) => prev + this.gain(x, expert, stat), 0)
      }
    },
    watch: {
      params () {
        this.reloadStats()
      }
    },
    mounted () {
      this.reloadStats()
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Accounting.vue